export default __webpack_public_path__ + "static/media/attractions8.e98962e7.avif";